import type { FaireProductEntity } from "../../entity_types/product";

export const p_29dy6bgx4k: FaireProductEntity = {
  token: "p_29dy6bgx4k",
  type: "product",
  name: "An Apple a Day Little Notes® Duo Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a3f017e4dc177993bcf3f64654762b4c6074c4832f97aadd3b2267e02ad4ce31.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/14be50e0c355b98b7bd1b680173847fee7bdc68069735e2e994a79acf155698f.jpeg",
    "https://cdn.faire.com/fastly/866a1621d1e8d08f54fd3b0e5e4c89492d0e09afcd8f34507c2aa3af6373ae3a.jpeg",
    "https://cdn.faire.com/fastly/8c69a9cd8b43e4e94eadd43d79959e9c9511bf1c347447c3a9e3322f848604ea.jpeg",
    "https://cdn.faire.com/fastly/db115e5c58a385e573e43d3a67663ad666573271b3d15e029c46e47b6fad9c82.jpeg",
  ],
  priceDollars: 6,
  description:
    "The cutest little duos you ever did see. Set of 10 Little Notes® and 10 Little Note Envelopes. These corresponding Little Notes® and printed envelopes take the surprise and delight of Little Notes to the next level - so up your gift tag/secret note/barista tip game! Please note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:28.832Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
